import { render, staticRenderFns } from "./atcSKU.vue?vue&type=template&id=52570231&"
import script from "./atcSKU.vue?vue&type=script&lang=ts&"
export * from "./atcSKU.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports